import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from 'src/app/shared/lib/api/graph.service';
import {
	GET_ALL_NOTAS_CREDITO,
	GET_ALL_NOTAS_CREDITO_PROVEEDORES,
	GET_NOTAS_CREDITO_BY_DATE_RANGE_AND_CLIENT,
	UPDATE_NOTA_CREDITO_PROVEEDOR,
} from '../graphql/notas-credito.queries';

@Injectable({
	providedIn: 'root',
})
export class NotasCreditoService {
	constructor(private graphService: GraphService) {}

	getAllNotasCredito(): Observable<any> {
		return this.graphService.queryGraphQL<any>({
			query: GET_ALL_NOTAS_CREDITO,
			variables: {},
		});
	}

	getAllNotasCreditoProveedores(): Observable<any> {
		return this.graphService.queryGraphQLSales<any>({
			query: GET_ALL_NOTAS_CREDITO_PROVEEDORES,
			variables: {},
		});
	}

	updateNotaCreditoProveedor({
		id,
		updates,
	}: {
		id: string;
		updates: any;
	}): Observable<any> {
		return this.graphService.mutateGraphQLSales<any>({
			mutation: UPDATE_NOTA_CREDITO_PROVEEDOR,
			variables: { id, updates },
		});
	}

	getAllByDateRangeAndClient(
		clientName: String,
		startDate: String,
		endDate: String,
	): Observable<any> {
		return this.graphService.queryGraphQL<any>({
			query: GET_NOTAS_CREDITO_BY_DATE_RANGE_AND_CLIENT,
			variables: { clientName, startDate, endDate },
		});
	}
}
